import { useParams } from "react-router";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "@refinedev/react-hook-form";
import { useTranslate } from "@refinedev/core";

import { ReferralFormValues, referralSchema } from "@modules/partners/validations";
import { useEditReferralMutation } from "@modules/partners/services/mutations";
import { useReferralHistoryQuery } from "@modules/partners/services/queries";

export function useReferralEditForm() {
  const { id } = useParams();
  const translate = useTranslate();
  const { mutateAsync, isPending } = useEditReferralMutation(id as string);
  const { data: history } = useReferralHistoryQuery(id);

  const methods = useForm<ReferralFormValues>({
    resolver: zodResolver(referralSchema()),
    mode: "onBlur",
    refineCoreProps: {
      resource: "v1/partner_referral_admin",
      action: "edit",
      id,
    },
  });

  const {
    handleSubmit,
    refineCore: { formLoading },
  } = methods;

  return {
    methods,
    handleSubmit,
    mutateAsync,
    isPending,
    formLoading,
    id,
    history,
    translate,
  };
}
